import Vue from "vue";
import router from "@/router";
import om from "../api";
import * as ACTIONS from "../config/constants/action-types";
import * as MUTATIONS from "../config/constants/mutation-types";
import { step1 } from "../config/constants/steps";
import { ERROR_TECNICO } from "../config/constants/step-constants";

export default {
  /**
   * Action disparada por el router en
   * cada actualización
   * @param {Object} context
   * @param {Object} payload
   */
  [ACTIONS.DO_ROUTE](context, payload) {
    context.commit(MUTATIONS.ON_ROUTE, payload);
    setTimeout(() => {
      // Detener loading al ingresar a ruta nueva
      // Lo hacemos en un timeout = 0 para hacer
      // al final del event loop
      context.commit(MUTATIONS.ON_IS_LOADING, false);
    }, 0);
  },
  [ACTIONS.DO_ROUTE_PUSH](context, ruta) {
    if (ruta !== undefined) {
      router.push(ruta);
    } else {
      context.dispatch(ACTIONS.DO_MENSAJE, ERROR_TECNICO);
    }
  },
  /**
   * Mostrar u ocultar el loader
   * @param {Object} context
   * @param {Object} payload
   */
  [ACTIONS.DO_IS_LOADING](context, payload) {
    context.commit(MUTATIONS.ON_IS_LOADING, payload);
  },

  /**
   * Actions disparadas por el
   * step navigator para avanzar pasos
   * Cada action guarda el paso
   * actual en el store
   * @param {Object} context
   */
  [ACTIONS.DO_LANDING]: (context, payload) => {
    context.commit(MUTATIONS.ON_IS_LOADING, true);
    context.commit(MUTATIONS.ON_LANDING, payload);
    context.dispatch(ACTIONS.DO_ROUTE_PUSH, "paso1");
  },
  [ACTIONS.DO_PASO1]: (context, payload) => {
    context.dispatch(ACTIONS.DO_ROUTE_PUSH, "paso2");
    context.commit(MUTATIONS.ON_PASO_1, payload);
  },
  [ACTIONS.DO_PASO2]: async (context, payload) => {
    context.commit(MUTATIONS.ON_IS_LOADING, true);
    context.commit(MUTATIONS.ON_PASO_2, payload);
    payload.cuit = payload.cuit.replace(/\D/g, "");

    let { paso1 } = context.state;
    const mergedPayload = {
      ...payload,
      ...paso1
    };
    Vue.$log.info("Va aConfirmo el turno");
    try {
      let response = await om.turnos.confirmar(mergedPayload);
      response = response.data;
      Vue.$log.debug(response);

      context.dispatch(ACTIONS.DO_PASO2_SUCCESS, response);
    } catch (error) {
      Vue.$log.error("Error no manejado en la llamada a la confirmacion");
      context.dispatch(ACTIONS.DO_PASO_ERROR, error);
    }
  },
  [ACTIONS.DO_PASO2_SUCCESS]: (context, payload) => {
    Vue.$log.info("Correcta llamada a confirmacion de turnos", payload);
    if (payload.respuesta) {
      const { respuesta } = payload.respuesta;
      if (respuesta) {
        Vue.$log.info(step1[respuesta]);
        Vue.$log.info(step1.OTORGADO);
        if (step1[respuesta] == step1.OTORGADO) {
          context.commit(MUTATIONS.ON_CONFIRMACION, payload);
          context.dispatch(ACTIONS.DO_ROUTE_PUSH, step1["OTORGADO"]);
        } else {
          context.dispatch(ACTIONS.DO_MENSAJE, step1[respuesta]);
        }
      } else {
        context.dispatch(ACTIONS.DO_MENSAJE, ERROR_TECNICO);
      }
    } else {
      context.dispatch(ACTIONS.DO_MENSAJE, ERROR_TECNICO);
    }
  },
  [ACTIONS.DO_GRACIAS]: (context, payload) => {
    context.commit(MUTATIONS.ON_GRACIAS, payload);
  },
  [ACTIONS.DO_PASO_ERROR]: (context, payload) => {
    Vue.$log.error(payload);
    context.dispatch(ACTIONS.DO_MENSAJE, ERROR_TECNICO);
  },

  /**
   * Mostrar un mensaje de error
   * @param {Object} context
   * @param {Object} payload Código del mensaje
   */
  [ACTIONS.DO_MENSAJE]: (context, payload) => {
    router.push({
      name: "mensaje",
      params: {
        mje: payload || ERROR_TECNICO
      }
    });
  },
  [ACTIONS.DO_MOCK]: (context, payload) => {
    context.commit(MUTATIONS.ON_MOCK, payload);
  },
  [ACTIONS.DO_FECHA_TURNO]: (context, payload) => {
    context.dispatch(ACTIONS.DO_ROUTE_PUSH, "confirmacion");
    context.commit(MUTATIONS.ON_FECHA_TURNO, payload);
  },
  [ACTIONS.DO_DATOS_PERSONALES]: async (context, payload) => {
    context.commit(MUTATIONS.ON_IS_LOADING, true);
    context.commit(MUTATIONS.ON_DATOS_PERSONALES, payload);
    payload.cuit = payload.cuit.replace(/\D/g, "");

    let { datosPersonales } = context.state;
    const mergedPayload = {
      ...payload,
      ...datosPersonales,
      camp: context.state.camp
    };
    Vue.$log.info("Invocamos consulta de turnos");
    try {
      let response = await om.turnos.getCitas(mergedPayload);
      response = response.data;
      Vue.$log.debug(response);

      context.dispatch(ACTIONS.DO_DATOS_PERSONALES_SUCCESS, response);
    } catch (error) {
      Vue.$log.error("Error no manejado en la llamada a la consulta de turnos");
      context.dispatch(ACTIONS.DO_PASO_ERROR, error);
    }
  },
  [ACTIONS.DO_DATOS_PERSONALES_SUCCESS]: (context, payload) => {
    Vue.$log.info("Correcta llamada a consulta de turnos", payload);
    if (payload && payload.status === "OK") {
      if (payload.respuesta !== null) {
        /* var binary = atob(payload.respuesta.pdf.replace(/\s/g, ""));
        var len = binary.length;
        var buffer = new ArrayBuffer(len);
        var view = new Uint8Array(buffer);
        for (let j = 0; j < len; j++) {
          view[j] = binary.charCodeAt(j);
        }
        let blob = new Blob([view], { type: "application/pdf" });
        let urlPDFBase64 = URL.createObjectURL(blob);

        context.commit(MUTATIONS.ON_TURNO_AGENDADO, {
          pdf: payload.respuesta.pdf,
          urlPdf: urlPDFBase64
        }); */
        context.commit(MUTATIONS.ON_TURNO_AGENDADO, payload);
        context.dispatch(ACTIONS.DO_ROUTE_PUSH, "turnoAgendado");
      } else {
        context.dispatch(ACTIONS.DO_GET_SUCURSALES, payload);
      }
    } else {
      context.dispatch(ACTIONS.DO_MENSAJE, ERROR_TECNICO);
    }
  },
  [ACTIONS.DO_GET_SUCURSALES]: async (context, payload) => {
    context.commit(MUTATIONS.ON_IS_LOADING, true);

    let { datosPersonales } = context.state;
    const mergedPayload = {
      ...payload,
      ...datosPersonales
    };

    try {
      let response = await om.turnos.getSucursales(mergedPayload);
      response = response.data;
      Vue.$log.debug(response);

      context.dispatch(ACTIONS.DO_GET_SUCURSALES_SUCCESS, response);
    } catch (error) {
      Vue.$log.error(
        "Error no manejado en la llamada a la consulta de sucursales"
      );
      context.dispatch(ACTIONS.DO_PASO_ERROR, error);
    }
  },
  [ACTIONS.DO_GET_SUCURSALES_SUCCESS]: (context, payload) => {
    Vue.$log.info("Correcta llamada a consulta de sucursales", payload);
    if (payload && payload.status === "OK") {
      if (payload.respuesta !== null) {
        context.commit(MUTATIONS.ON_SUCURSALES, payload.respuesta);
        context.dispatch(ACTIONS.DO_ROUTE_PUSH, "datosSucursal");
      } else {
        context.dispatch(ACTIONS.DO_MENSAJE, ERROR_TECNICO);
      }
    } else {
      context.dispatch(ACTIONS.DO_MENSAJE, ERROR_TECNICO);
    }
  },
  [ACTIONS.DO_DATOS_SUCURSAL]: async (context, payload) => {
    context.commit(MUTATIONS.ON_IS_LOADING, true);
    context.commit(MUTATIONS.ON_DATOS_SUCURSAL, payload);

    let { datosSucursal } = context.state;
    let { datosPersonales } = context.state;
    const mergedPayload = {
      ...payload,
      ...datosSucursal,
      ...datosPersonales,
      sucursalId: payload.numeroSucursal
    };
    Vue.$log.info("Invocamos consulta de tramites");
    try {
      let response = await om.turnos.getTramites(mergedPayload);
      response = response.data;
      Vue.$log.debug(response);

      context.dispatch(ACTIONS.DO_DATOS_SUCURSAL_SUCCESS, response);
    } catch (error) {
      Vue.$log.error(
        "Error no manejado en la llamada a la consulta de tramites"
      );
      context.dispatch(ACTIONS.DO_PASO_ERROR, error);
    }
  },
  [ACTIONS.DO_DATOS_SUCURSAL_SUCCESS]: (context, payload) => {
    Vue.$log.info("Correcta llamada a consulta de tramites", payload);
    if (payload && payload.status === "OK") {
      if (payload.respuesta !== null) {
        context.commit(MUTATIONS.ON_TIPOS_TRAMITE, {
          tramites: payload.respuesta
        });
        context.dispatch(ACTIONS.DO_ROUTE_PUSH, "tiposTramite");
      } else {
        context.dispatch(ACTIONS.DO_MENSAJE, ERROR_TECNICO);
      }
    } else {
      context.dispatch(ACTIONS.DO_MENSAJE, ERROR_TECNICO);
    }
  },
  [ACTIONS.DO_TIPOS_TRAMITE]: async (context, payload) => {
    context.commit(MUTATIONS.ON_IS_LOADING, true);
    context.commit(MUTATIONS.ON_TIPOS_TRAMITE, payload);

    let { datosSucursal } = context.state;
    let { datosPersonales } = context.state;
    const hoy = new Date();
    const meses = [hoy.getMonth() + 1, hoy.getMonth() + 2];
    const mergedPayload = {
      ...payload,
      ...datosSucursal,
      ...datosPersonales,
      organizationId: datosSucursal.numeroSucursal,
      serviceId: payload.tramiteSeleccionado,
      month: meses,
      year: hoy.getFullYear()
    };
    Vue.$log.info("Invocamos consulta de dias");
    try {
      let response = await om.turnos.getDias(mergedPayload);
      response = response.data;
      Vue.$log.debug(response);

      context.dispatch(ACTIONS.DO_TIPOS_TRAMITE_SUCCESS, response);
    } catch (error) {
      Vue.$log.error("Error no manejado en la llamada a la consulta de dias");
      context.dispatch(ACTIONS.DO_PASO_ERROR, error);
    }
  },
  [ACTIONS.DO_TIPOS_TRAMITE_SUCCESS]: (context, payload) => {
    Vue.$log.info("Correcta llamada a consulta de dias", payload);
    if (payload && payload.status === "OK") {
      if (payload.respuesta !== null) {
        context.commit(MUTATIONS.ON_FECHA_TURNO, {
          fechasDisponibles: payload.respuesta
        });
        context.dispatch(ACTIONS.DO_ROUTE_PUSH, "fechaTurno");
      } else {
        context.dispatch(ACTIONS.DO_MENSAJE, ERROR_TECNICO);
      }
    } else {
      context.dispatch(ACTIONS.DO_MENSAJE, ERROR_TECNICO);
    }
  },

  [ACTIONS.DO_FECHA_HORA]: async (context, payload) => {
    context.commit(MUTATIONS.ON_IS_LOADING, true);

    let { datosSucursal } = context.state;
    let { datosPersonales } = context.state;
    let { tiposTramite } = context.state;

    const mergedPayload = {
      ...payload,
      ...datosSucursal,
      ...datosPersonales,
      organizationId: datosSucursal.numeroSucursal,
      serviceId: tiposTramite.tramiteSeleccionado,
      year: payload.fechaSeleccionada.substring(0, 4),
      month: payload.fechaSeleccionada.substring(4, 6),
      day: payload.fechaSeleccionada.substring(6, 8)
    };
    Vue.$log.info("Invocamos consulta de dias");
    try {
      let response = await om.turnos.getHoras(mergedPayload);
      response = response.data;
      Vue.$log.debug(response);

      context.dispatch(ACTIONS.DO_FECHA_HORA_SUCCESS, response);
    } catch (error) {
      Vue.$log.error("Error no manejado en la llamada a la consulta de dias");
      context.dispatch(ACTIONS.DO_PASO_ERROR, error);
    }
  },
  [ACTIONS.DO_FECHA_HORA_SUCCESS]: (context, payload) => {
    Vue.$log.info("Correcta llamada a consulta de dias", payload);
    if (payload && payload.status === "OK") {
      if (payload.respuesta !== null) {
        let horariosConTurno = payload.respuesta;
        horariosConTurno = horariosConTurno.filter(f => {
          return f && f.available && f.available === "true";
        });

        horariosConTurno = horariosConTurno.map(s => {
          let hora = {
            label: s.hour + ":" + s.minute + " hs",
            value: s.hour + ":" + s.minute
          };
          return hora;
        });

        context.commit(MUTATIONS.ON_HORA_TURNO, {
          horariosDisponibles: horariosConTurno
        });
        context.commit(
          MUTATIONS.ON_FECHA_TURNO_HORADEFAULT,
          horariosConTurno[0].value
        );
        context.commit(MUTATIONS.ON_IS_LOADING, false);
       // context.dispatch(ACTIONS.DO_ROUTE_PUSH, "fechaTurno");
      } else {
        context.dispatch(ACTIONS.DO_MENSAJE, ERROR_TECNICO);
      }
    } else {
      context.dispatch(ACTIONS.DO_MENSAJE, ERROR_TECNICO);
    }
  },
  [ACTIONS.DO_CONFIRMACION]: async (context, payload) => {
    context.commit(MUTATIONS.ON_IS_LOADING, true);

    let { datosSucursal } = context.state;
    let { datosPersonales } = context.state;
    let { tiposTramite } = context.state;
    let { fechaTurno } = context.state;
    let { horaTurno } = context.state;
    const year = fechaTurno.fechaSeleccionada.substring(0, 4);
    const month = fechaTurno.fechaSeleccionada.substring(4, 6);
    const day = fechaTurno.fechaSeleccionada.substring(6, 8);
    const hora = fechaTurno.horaSeleccionada.replace(":", "");
    const mergedPayload = {
      ...datosPersonales,
      sucursalId: datosSucursal.numeroSucursal,
      serviceId: tiposTramite.tramiteSeleccionado,
      appointmentDate: year + month + day + "T" + hora,
      camp: context.state.camp,
      direccionSucursal: datosSucursal.addressSucursal,
      descripcionSucursal: datosSucursal.citySucursal,
      codeSucursal: datosSucursal.code
    };
    Vue.$log.info("Invocamos creacion de turno");
    try {
      let response = await om.turnos.crearTurno(mergedPayload);
      response = response.data;
      Vue.$log.debug(response);

      context.dispatch(ACTIONS.DO_CONFIRMACION_SUCCESS, response);
    } catch (error) {
      Vue.$log.error("Error no manejado en la llamada a la consulta de dias");
      context.dispatch(ACTIONS.DO_PASO_ERROR, error);
    }
  },
  [ACTIONS.DO_CONFIRMACION_SUCCESS]: (context, payload) => {
    Vue.$log.info("Correcta llamada a creacion de turno", payload);
    if (payload && payload.status === "OK") {
      if (payload.respuesta !== null) {
        let binary = atob(payload.respuesta.pdf.replace(/\s/g, ""));
        let len = binary.length;
        let buffer = new ArrayBuffer(len);
        let view = new Uint8Array(buffer);
        for (let j = 0; j < len; j++) {
          view[j] = binary.charCodeAt(j);
        }
        let blob = new Blob([view], { type: "application/pdf" });
        let urlPDFBase64 = URL.createObjectURL(blob);

        context.commit(MUTATIONS.ON_GRACIAS_PERSONAS, {
          pdf: payload.respuesta.pdf,
          urlPdf: urlPDFBase64
        });
        context.commit(MUTATIONS.ON_IS_LOADING, false);
        context.dispatch(ACTIONS.DO_ROUTE_PUSH, "gracias");
      } else {
        context.dispatch(ACTIONS.DO_MENSAJE, ERROR_TECNICO);
      }
    } else {
      if (
        payload &&
        payload.respuesta !== null &&
        payload.respuesta === "EXISTING_APPOINTMENT"
      ) {
        context.commit(MUTATIONS.ON_TURNO_AGENDADO, payload);
        context.dispatch(ACTIONS.DO_ROUTE_PUSH, "turnoAgendado");
      } else {
        context.dispatch(ACTIONS.DO_MENSAJE, ERROR_TECNICO);
      }
    }
  }
};
